import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import type { TxKind } from '@aslen/core';

export type QuickAction =
  | { kind: 'transaction'; txKind: TxKind; accountId?: string; contactId?: string; invoiceId?: string; transferAccountId?: string }
  | { kind: 'invoice'; type: 'sale' | 'purchase'; id?: string; contactId?: string }
  | { kind: 'contact'; id?: string; type?: string }
  | { kind: 'account'; id?: string };

interface QuickActionsApi {
  current: QuickAction | null;
  open(a: QuickAction): void;
  close(): void;
}

const Ctx = createContext<QuickActionsApi | null>(null);

/** One drawer at a time, opened from anywhere (quick actions, ⌘K, shortcuts, row buttons). */
export function QuickActionsProvider({ children }: { children: ReactNode }) {
  const [current, setCurrent] = useState<QuickAction | null>(null);
  const open = useCallback((a: QuickAction) => setCurrent(a), []);
  const close = useCallback(() => setCurrent(null), []);
  return <Ctx.Provider value={{ current, open, close }}>{children}</Ctx.Provider>;
}

export function useQuickActions(): QuickActionsApi {
  const v = useContext(Ctx);
  if (!v) throw new Error('useQuickActions outside provider');
  return v;
}
